module.exports = __webpack_public_path__ + "img/Invasion-OVCA_GSE227019.3abf1ce3.png";